import script from "./PolicyConfigurationSettingsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicyConfigurationSettingsTable.vue?vue&type=script&setup=true&lang=ts"

import "./PolicyConfigurationSettingsTable.vue?vue&type=style&index=0&id=616999ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616999ed"]])

export default __exports__